/**
 * Mutación que lista las empresas en el formulario.
 *
 * @param {*} state contiene la informacion de variables del formulario.
 * @param {*} empresas contiene la información de las empresas.
 */
export function setListaEmpresa(state, empresas) {
    state.empresas = empresas
}

/**
 * Mutación que carga la información de los documentos.
 *
 * @param {*} state contiene la informacion de variables del formulario.
 * @param {*} tree contiene la información de los documentos.
 */
export function cargarTreeEmpresa(state, tree) {
    state.treeInfo = [];
    state.treeInfo = tree;
}

/**
 * Mutación que limpia los campos del formulario.
 *
 * @param {*} state contiene la información de las variables del formulario.
 */
export function limpiarCampos(state) {
    state.selectedDocumentos.descripcion = '';
    state.selectedDocumentos.adjunto = null;
    state.selectedDocumentos.activo = true;
    state.selectedDocumentos.tipo = 'file';
    state.selectedDocumentos.nodeActiveId = null
}

/**
 * Mutación que limpia la información de los documentos.
 *
 * @param {*} state contiene la informacion de variables del formulario.
 */
export function limpiaEmpresa(state) {

    state.treeInfo = [];
    state.selectedDocumentos.treeVisible = false;
    state.selectedDocumentos.empresa = '';
}

/**
 * Mutación que carga la url para descargar el documento.
 *
 * @param {*} state contiene la informacion de variables del formulario.
 * @param {*} url contiene la información de la url de descarga.
 */
export function setUrlDocumento(state, url) {

    state.urlDescarga = url;

}

/**
 * Mutación actualiza los dotumentos buscados en el servidor.
 *
 * @param {*} state contiene la informacion de variables del formulario.
 * @param {*} documents documentos a cargar.
 */
export function setDocuments(state, documents) {
    state.documents = documents;
}

/**
 * Mutación actualiza los documentos o folder seleccionados.
 *
 * @param {*} state contiene la informacion de variables del formulario.
 * @param {*} document documentos a cargar.
 */
export function setSelectedDocument(state, document) {
    state.selectedDocument = document;
}
